/* angular */
import { Injectable } from '@angular/core';

/* rxjs */
import { Observable } from 'rxjs/Observable';
import { Subscriber } from 'rxjs/Subscriber';

import { User } from '@api/models/user';
import { HttpThresholdService } from '../services/http-threshold.service';
import { UserProfile } from '../models/user';
import { UserFeatureFlags } from '@threshold/models/user-flags';
import { FeatureFlagService } from './feature-flag.service';
import { HelperStorage } from './../storage-helper';
import { TextEncoderService } from './text-encoder.service';

const featureFlagLocalStorage = new HelperStorage('localStorage', '', '');

declare var window: any;

@Injectable()
export class UserProfileService {

	private oidc: any;
	localStorageFeatureFlagUserKey: string;
	localStorageFeatureFlagCreatedKey: string;
	localStorageFeatureFlag: string = 'ff';

	/**
	 *
	 * @param httpThreshold
	 */
	constructor(protected httpThreshold: HttpThresholdService,
		private featureFlagService: FeatureFlagService,
		private textEncoderService: TextEncoderService) {
		this.oidc = window._oidc;
	}

	/**
	 *
	 *
	 */
	getUserProfiles(user: User): Observable<UserProfile[]> {
		return Observable.create((subscriber: Subscriber<UserProfile[]>) => {
			if (this.oidc) {
				this.oidc.metadataService._getMetadataProperty('user-profiles').then(url => {

					this.httpThreshold.get(url).subscribe(response => {
						let userProfiles: UserProfile[] = [];

						(response.json().userProfiles as UserProfile[]).forEach(profile => {
							profile.isSelected = profile.userProfileId == user.id;
							profile.switchUrl = `profile-switch/${profile.userProfileId}`;
							userProfiles.push(profile);
						});

						if ((typeof fft !== 'undefined')) {
							fft && fft('usergroup', userProfiles.some(up => up.isSelected) ? userProfiles.find(up => up.isSelected).companyProfileId : '');
						}

						subscriber.next(userProfiles);
						subscriber.complete();
					});

				});
			} else {
				subscriber.next([]);
				subscriber.complete();
			}
		});
	}

	setFeatureFlagsConfig() {
		return Observable.create((subscriber: Subscriber<any>) => {
			// if user auth is turned off then resolve for local development
			if (this.userNotAuthenticated()) {
			} else {
				this.oidc.getUser().then((user) => {
					if (user) {
						this.localStorageFeatureFlagUserKey = `ff.${user.profile.sub}`;
						this.localStorageFeatureFlagCreatedKey = `ff.created.${user.profile.sub}`;
					}

					//Make API call if there are feature flags, a userId and 59 minutes have passed or if there are no feature flags
					if ((this.getFeatureFlagsFromLocalStorage() !== null && this.haveFlagsExpired(59)) || this.getFeatureFlagsFromLocalStorage() === null) {
						this.featureFlagService.getLatestFlags().subscribe((response: UserFeatureFlags[]) => {
							this.setFeatureFlagsOnLocalStorage(response.map((res) => res.name));
							subscriber.next(true);
							subscriber.complete();
						},
							(error) => {
								if (this.getFeatureFlagsFromLocalStorage() !== null) {
									// if API call fails return localstorage values
									subscriber.next(true);
									subscriber.complete();
								} else {
									// if first time loading values and API call fails app errors out
									window.location = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '') + `/authentication-error.html`
									subscriber.next(true);
									subscriber.complete();

								}
							});
					} else {
						// LocalStorage is not null and time has not expired then Resolve() and dont make api call
						subscriber.next(true);
						subscriber.complete();
					}
				});
			}
		});
	}

	haveFlagsExpired(minutes: number) {
		if (this.getFeatureFlagsFromLocalStorage() !== null) {
			const authTimePast = JSON.parse(localStorage.getItem(this.localStorageFeatureFlagCreatedKey));
			const minutesBeforeExpired = 1000 * 60 * minutes;

			return (new Date().getTime() - authTimePast < minutesBeforeExpired) ? false : true;
		}
	}

	getFeatureFlagsFromLocalStorage() {
		// if user auth is turned off then return empty array for local development
		if (this.userNotAuthenticated()) {
			return [];
		} else if(localStorage.getItem(this.localStorageFeatureFlag)){
			return this.textEncoderService.getDecodedValue(localStorage.getItem(this.localStorageFeatureFlag));
		}
	}

	setFeatureFlagsOnLocalStorage(flags: string[]) {
		const encodedFlags = this.textEncoderService.getEncodedValue(JSON.stringify(flags));
		featureFlagLocalStorage.set(this.localStorageFeatureFlagUserKey, JSON.stringify(encodedFlags));
		featureFlagLocalStorage.set(this.localStorageFeatureFlagCreatedKey, new Date().getTime());
		featureFlagLocalStorage.set(this.localStorageFeatureFlag, JSON.stringify(encodedFlags));
	}


	getFeatureFlagMatch(flag: string[]): Observable<boolean> {
		return Observable.create((subscriber: Subscriber<any>) => {
			const localStorageFlags = JSON.parse(this.getFeatureFlagsFromLocalStorage());
			const noFeatureFlagMatchFound = flag.every(flag => localStorageFlags.indexOf(flag) === -1);
			subscriber.next(noFeatureFlagMatchFound);
			subscriber.complete();
		});
	}

	userNotAuthenticated() {
		return window['__NOT_USE_AUTHENICATION'];
	}
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/services/user-profile.service.ts